<div class="field-and-palette-container">
  <mode-labeled-field-list-menu
    label="Field"
    [selected]="selectedField"
    [otherFields]="otherFields"
    [disabled]="otherFields.length <= 1"
    (menuChange)="onFieldChanged($event)"
  ></mode-labeled-field-list-menu>

  <mode-color-palette-selector
    [selectedColorPalette]="activeColorPalette"
    [allColorPalettes]="allColorPalettes"
    (paletteChanged)="onPaletteChanged($event)"
    buttonHeight="normal"
    label="Palette"
  ></mode-color-palette-selector>
</div>
